<template>
    <div style="height:100%;min-height:700px;" class="loginBg">
      <div class="footerPosition">
        <div class="topLogo">
          <div class="topLeft"><router-link to="/"><img src="../../../assets/img/logoWhite.png" width="170" /></router-link> </div>
          <div class="topRight">
            <a href="/">HOME</a>
          </div>
         </div>
        <div class="loginMain">
          <div class="loginLeft">
            <b class="lineWhite"></b>
             <h3>Freightshop Mission: to create more efficient and satisfying international logistics services</h3>
             <p>Make the complicated things simplified, and do the simplified things to the best. </p>
            <b class="lineWhite"></b>
          </div>
          <div class="loginRight">
            <div class="loginLogo"><img src="../../../assets/img/logoBlue.png" width="165" /></div>
            <div class="errorTips" v-if="IsVerification"> 
              <p>{{VerificationMsg}}</p>
              <p v-if="IsEmailId">Your email address is not activated. Please click activate</p>
            </div>
             <div class="errorTips" v-if="IsEmailId">
              <p @click="Activation()" style="cursor: pointer">Your email address is not activated. Please click activate</p>
            </div>
            <ul>
              <li>
                <input type="text" maxlength=100 size="50" placeholder="Email" @blur="IsloginEmail()" v-model="loginEmail" class="loginInput" :class="IsEmail ? 'borRed' : ''" @keyup.enter="Login()">
              </li>
              <li>
                <input type="password" maxlength=100 placeholder="Password" @blur="IsloginPassword()" v-model="loginPassword" class="loginInput" :class="Ispassword ? 'borRed' : ''" @keyup.enter="Login()">
              </li>
              <li><a class="aLink" @click="FindPwd()">Forget Password？</a></li>
              <li style="clear:both">
                <input type="submit" value="LOGIN" @click="Login()" class="loginBtn">
              </li>
              <li class="spcBot">
                <span>No account yet?</span><a href="/reg/registerPeer"> Sign Up</a>

              </li>
            </ul>
          </div>
        </div>
        <div class="BottomText">
                <span>Copyright © 2019 Freightshop</span>
                <a class="marL20" href="/Terms">Terms and Conditions</a>
                <em style="margin:0 5px;color:#ddd">|</em>
                <a href="/privacy">Privacy Policy</a>
                <em style="margin:0 5px;color:#ddd">|</em>
                <a href="/refund">Refund and Cancellation Policy</a>
            </div>
        
        <!-- <div class="footer"><p>2019 Shenzhen Freightshop Technology Co., Ltd. All rights reserved</p></div> -->
      </div>
    </div>
</template>

<script type="text/ecmascript-6">
import { post, fetch, Del, put } from "../../../ask/axios";
import {setCookie} from '../../../ask/cookiejs'
import footerInfo from '../public/footerInfo.vue'
import  { browserHref } from '../../../utils/download.js';
    export default {
        components:{footerInfo},
        data (){
            return {
               api: {
               url: "",
               param: "",
               response: {},
               message: ""
                },
              //邮箱
              loginEmail:'',
              //是否显示邮箱验证红框
              IsEmail:false,
              //验证邮箱是否存在显示
              IsEmailId:false,
              //密码
              loginPassword:'',
              //密码是否输入
              Ispassword:'',
              //验证提示
              VerificationMsg:'',
              //是否显示提示
              IsVerification:false,
            }
        },
        created(){
          // 键盘按下回车，马上执行Login
         this.downLogin();
         

        },
        methods: {
          
          //键盘按下回车，马上执行Login
          downLogin() {
            let that = this;
            document.onkeydown = function(e) {
            let key = window.event.keyCode;
            if (key == 13) {
              that.Login();
              }
            }
          },
          //登陆按钮
          Login(){
            if(this.loginEmail==null||this.loginEmail==''||this.loginPassword==null||this.loginPassword==''){
              this.VerificationMsg='Please enter your email address and login password';
              this.IsVerification=true;
              this.Ispassword=true;
              this.IsEmail=true;
            }else{
              this.VerificationMsg='';
              this.IsVerification=false;
              this.IsloginEmail();
              this.Loginapi();
            }
          },
          FindPwd(){
             window.location.href='/reg/findPwd'
          },
          //登陆api
          Loginapi(){
           let that = this;
            if(that.ActivationExist()){
              that.api.param={
               "UserName": this.loginEmail,
               "Password": this.loginPassword,
               "anonymousId":sensors.quick('getAnonymousID'),
               "platform_type":'web'
             }
              that.api.url=that.$api02+"/api/EbayCustomer/CustomerInfo/Login_En";
              post(that.api.url,that.api.param).then(function(res){
                setCookie('X-BY-EnTOKEN',res.Results.Token);
                setCookie('IMEn-TOKEN',res.Results.IMToken);

                sensors.login(res.Results.UserID)
                
               if(res.ErrorCode=='C0001'){
                 if(that.$route.query.ReturnUrl){
                    // window.location.href=that.$route.query.ReturnUrl;
                    //that.$router.push(that.$route.query.ReturnUrl)
                    console.log(111111111);
                    browserHref(that.$route.query.ReturnUrl, 1)
                   
                 }else{
                    
                    // let url=that.$api02+'/api/EbayCustomer/CustomerInfo/GetCustomerInfoByToken';
                    let url=that.$api04 + "/Basics/api/CustomerInfo/GetCustomerInfoByToken";
                    let param={}
                    post(url,param).then((res)=>{
                        if(res.Results){
                          //console.log('res.Results '+  JSON.stringify(res.Results));
                          setCookie("saveCustomerOwnerType", JSON.stringify(res.Results));
                          //window.location.href='/checkList/quotes';
                          // window.history.back(-1);
                          browserHref('/', 1)
                        }
                    })
                    
                 }
                 
                }else if(res.ErrorCode=='S1006'){
                 that.VerificationMsg='Wrong email or password';
                 that.IsVerification=true;
                }else if(res.ErrorCode=='S1005'){
                  that.VerificationMsg='This account has been disabled,please contact the customer service for processing';
                  that.IsVerification=true;
                }else if(res.ErrorCode=='S1002'){
                   that.VerificationMsg='Wrong email or password';
                   that.IsVerification=true;
                }else if(res.ErrorCode=='S1007'){
                  that.IsEmailId=true;
                }else if(res.ErrorCode=='S1004'){
                 that.VerificationMsg='Your account is not registered on en.by56.com and cannot be logged in.';
                 that.IsVerification=true;
                } else if(res.ErrorCode=='S1013'){
                 that.VerificationMsg='Your account has been locked, please contact the main account owner or customer service';
                 that.IsVerification=true;
                } 

                //埋点 
               // that.loginResult(res.IsOK,that.VerificationMsg)

              //  sensors.track('login_result', {
              //       login_method:'邮箱',
              //       is_quick_login:false, 
              //       is_success:res.IsOK,
              //       fail_reason:that.VerificationMsg,
              //     });
                that.getLoginInfo(res.IsOK,that.VerificationMsg,res.Results.UserID,sensors.quick('getAnonymousID'))

              })
            }
          },
          //埋点成功后传信息到接口中  
          getLoginInfo(isSuc,fail,id,anonymousId){
            let that = this;
            that.api.param={
              login_method:'邮箱',
              is_quick_login:false,
              is_success:isSuc,
              fail_reason:fail,
              UserId:id ,
              app_name:'电商Web端',
              platform_type:'web',
              is_login:true,
              anonymousId:anonymousId,
              }
              // that.api.url=this.$api02+"/api/EbayCustomer/Login/GetLoginInfoSync";
              that.api.url = this.$api04 + "/Basics/api/Login/GetLoginInfoSync";
              post(that.api.url,that.api.param).then(function (res) {
                
            })
          },

          SendMail(){
            let that = this;
            that.api.param={
              email:this.loginEmail
          }
          that.api.url=this.$api02+"/api/EbayCustomer/NewAccountInfo/NewAccountInfoSendEmail";
          fetch(that.api.url,that.api.param).then(function (res) {
            if(res.IsOK==true){
              //  注册成功
               window.location.href ="/reg/emailAct??Email="+that.EmailId
              
            }
          })
          },
          ActivationExist(){
            let that = this;
            //验证邮箱是否激活
            if(that.loginEmail=='123456@qq.com'){
              that.IsEmailId=true;
              return false
            }else{
             that.IsEmailId=false;
             return true
            }

          },
          //发送邮件
          Activation(){
            this.SendMail()
             window.location.href='/reg/emailAct?Email='+this.loginEmail+'&Vcode='+''+'&AccountID='+''+'&SendTime='+'';
             return false;
          },
          //邮箱失去焦点事件
          IsloginEmail(){
            var regEmail= /^([a-zA-Z0-9_.-])+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
           this.loginEmail=this.loginEmail.replace(/(^\s*)|(\s*$)/g, "");
             if(!regEmail.test(this.loginEmail)){ //只能输入邮箱格式
                this.IsEmail=true;
                this.IsVerification=true;
                this.VerificationMsg='Please enter a valid email address'
                }else{
                this.IsEmail=false;
                this.IsVerification=false;
                this.VerificationMsg='';
                return this.EmailId
              }
          },
          IsloginPassword(){

          },

        }
    }
</script>

<style lang="less" scoped="scoped">
  @import "../../../assets/css/regLog.less";
.topLogo{width:1200px;margin:auto;height:76px;}
.topLogo .topLeft{float:left;margin-top:15px;}
.topLogo .topRight{float:right;line-height:76px;font-size:16px;color:#fff;}
.topLogo .topRight a{margin-left:20px;font-size:16px;color:#fff;}
.topLogo .topRight a b{color:#fff;}
.footer{position:absolute;bottom:0;text-align:center;width:100%;height:60px;line-height:60px;}
.footer p{color:#fff;font-size:13px;text-align:center}

.footerPosition{padding-bottom:0px !important;}

  .loginBg{background:url("../../../assets/img/login-allbg.jpg") no-repeat center;}
  .loginMain{color:#fff;width:1200px;margin:50px auto;}
  .loginMain .loginLeft{width:700px;float:left;margin-top:50px;}
 .loginMain .loginLeft .lineWhite{background:#fff;width:100px;height:2px;display:block;margin:50px 0}
 .loginMain .loginLeft h3{font-size:26px;line-height:40px;margin-bottom:15px;}
 .loginMain .loginLeft p{font-size:14px;line-height:30px;}
 .loginMain .loginRight{float:right;border:1px solid #ddd;width:360px;height:450px;background-color:#eeeff1;border-radius:10px;background-image:url(../../../assets/img/en-log-map.png);background-repeat:no-repeat;background-position:top center;margin-top:30px;position:relative;}
.loginMain .loginRight .loginLogo{margin-top:60px;}
.loginMain .loginRight .loginLogo img{margin:auto;}
  .loginMain .loginRight ul{margin:70px 0 30px 0;}
 .loginMain .loginRight ul li{margin:20px;}
  .loginMain .loginRight ul li .aLink{float:right;color:#004FB1;font-size:14px;margin-top:-10px;}
  .loginBtn{background:#004FB1;color:#fff;border:0px;width:98%;height:38px;border-radius:30px;margin-top:20px;cursor:pointer;font-size:16px;}
  .loginBtn:focus, .loginBtn:active{border-radius:30px !important;}


  .errorTips{position:absolute;color:red;background:#FFF3F3;border:1px solid #FFBFBF;width:85%;margin:20px;padding:6px;border-radius:5px;}
  .spcBot{text-align:center;text-align:center;color:#666;font-size:14px;}
  .spcBot a{color:#004FB1;font-size:14px;margin-left:10px;}

  //input边框样式
  .loginInput{border-radius:5px;border:1px solid #dcdfe6;line-height:38px;height:38px;padding-left:5px;font-size:14px;width:98%;}

.BottomText{position:absolute;bottom:0;text-align:center;width:100%;height:60px;line-height:60px;z-index:8;}
.BottomText span{color:#c7c7c7 !important;}
.BottomText a{color:#c7c7c7 !important;}
.BottomText a:hover{color:#fff !important;}
</style>



// WEBPACK FOOTER //
// src/components/reception/reg/login.vue